import { put, select, fork } from 'redux-saga/effects';
import Cookies from 'js-cookie';
import AppActions, { LOGIN_PAGES } from '@redux/AppRedux';
import logger from '@utils/logger';
import AuthActions, { AuthSelectors } from './AuthRedux';
import BookingActions from './BookingRedux';
import ScheduleActions from './ScheduleRedux';
import API from '@utils/api';
import {
  transformInitialAppData,
  transformBlockedDays
} from '@services/transform';
import {
  segmentAlias,
  segmentIdentify,
  trackLogIn,
  trackSignUp
} from '@services/analytics';
import { loadSubscriptions } from './SubscriptionSaga';
import { BOOKING_STAGE, USER_ROLES } from '@services/minte';

export function* startup() {
  const authToken = Cookies.get('authToken');
  const refreshToken = Cookies.get('refreshToken');

  if (refreshToken) {
    try {
      const { result: newAuthToken } = yield API.getAuthToken({
        authToken,
        refreshToken
      });
      yield put(
        AuthActions.setLoggedIn({
          authToken: newAuthToken,
          refreshToken
        })
      );

      yield put(AppActions.setAppDataLoadRequest());
    } catch (err) {
      logger.log('error on refreshing token on reload');
    }
  }

  yield put(AppActions.setLoaded(true));
}

export function* loadAppdata(action) {
  const { isFrom } = action;
  yield put(AppActions.setLoading(true));
  let user;

  try {
    const { result } = yield API.getUserProfile();
    user = result;
    yield put(AuthActions.setUser(user));

    //
  } catch (err) {
    logger.log('error on getting userInfo');
  }

  const state = yield select();
  if (isFrom && isFrom === LOGIN_PAGES['LOG_IN']) {
    segmentIdentify(state);
    trackLogIn(state);
  } else if (isFrom && isFrom === LOGIN_PAGES['SIGN_UP']) {
    segmentAlias(state.auth.me.userID);
    segmentIdentify(state);
    trackSignUp(state);
  } else {
    segmentIdentify(state);
  }

  const { propertyID, role } = user || {};

  if (propertyID || role === USER_ROLES.PROPERTY_MANAGER) {
    try {
      const { result } = yield API.getAppData();
      const transformed = transformInitialAppData(result);
      yield put(AppActions.setAppData(transformed));
      yield put(ScheduleActions.setAllPackages(transformed.packageTypes));
    } catch (err) {
      logger.log('error on app data');
    }
  }

  if (role && role !== USER_ROLES.PROPERTY_MANAGER && propertyID) {
    try {
      const { result: propertySetting } = yield API.getPropertySettingStatus();
      yield put(AuthActions.setUserSettings(propertySetting));
    } catch (err) {
      logger.log('error on getting property setting');
    }

    try {
      const { result: propertyInfo } = yield API.getPropertyById(propertyID);
      const { blockedDays } = propertyInfo || {};
      yield put(
        ScheduleActions.setRecurringBlockedDays(
          transformBlockedDays(blockedDays || [])
        )
      );
    } catch (err) {
      logger.log('error on getting property blocked days');
    }

    try {
      yield fork(loadSubscriptions); // called for analytics function - refactor
    } catch (err) {
      logger.log('error on loading subsciption');
    }

    yield put(BookingActions.setIsForPropertyManager(false));
    yield put(BookingActions.setBookingStep(BOOKING_STAGE.FREQUENCY));
  } else {
    yield put(BookingActions.setIsForPropertyManager(true));
    yield put(BookingActions.setBookingStep(BOOKING_STAGE.RECIPIENT));
  }

  yield put(AppActions.setLoading(false));
}

export function* loadPriceData() {
  const user = yield select(AuthSelectors.selectCurrentUser);

  const { propertyID, role } = user || {};

  if (propertyID || role === USER_ROLES.PROPERTY_MANAGER) {
    try {
      const { result } = yield API.getAppData();
      const transformed = transformInitialAppData(result);
      yield put(AppActions.setAppData(transformed));
      yield put(ScheduleActions.setAllPackages(transformed.packageTypes));
    } catch (err) {
      logger.log('error on app data');
    }
  }
  if (role && role !== USER_ROLES.PROPERTY_MANAGER && propertyID) {
    try {
      const { result: propertyInfo } = yield API.getPropertyById(propertyID);
      const { blockedDays } = propertyInfo || {};
      yield put(
        ScheduleActions.setRecurringBlockedDays(
          transformBlockedDays(blockedDays || [])
        )
      );
    } catch (err) {
      logger.log('error on getting property blocked days');
    }

    try {
      const { result: propertySetting } = yield API.getPropertySettingStatus();
      yield put(AuthActions.setUserSettings(propertySetting));
    } catch (err) {
      logger.log('error on getting property setting');
    }
  }
}
